import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=eaa9bd1e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=eaa9bd1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaa9bd1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eaa9bd1e')) {
      api.createRecord('eaa9bd1e', component.options)
    } else {
      api.reload('eaa9bd1e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=eaa9bd1e&scoped=true&", function () {
      api.rerender('eaa9bd1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4txOZF42RsXAR/JS/comp/DocBox.vue"
export default component.exports